import { createReducer } from "@reduxjs/toolkit";
import { AgentTabView } from "constants/ChatViewConstants";
import { CHANGE_AGENT_TAB } from "actions/types";

const initialState = {
  section: AgentTabView.AGENT_CHAT,
};
const agentTabReducer = createReducer(initialState, {
  [CHANGE_AGENT_TAB]: (state, action) => {
    state.section = action.payload;
    return state;
  },
});

export default agentTabReducer;
